var map = {
	"./ecosystem.en.json": [
		69549,
		9299
	],
	"./ecosystem.es.json": [
		74534,
		8132
	],
	"./ecosystem.fr.json": [
		4478,
		8944
	],
	"./ecosystem.pt.json": [
		72258,
		6048
	],
	"./home-teaser.en.json": [
		18703,
		8157
	],
	"./home-teaser.es.json": [
		15336,
		2214
	],
	"./home-teaser.fr.json": [
		24908,
		9678
	],
	"./home-teaser.pt.json": [
		78544,
		1070
	],
	"./wheel.en.json": [
		72324,
		5186
	],
	"./wheel.es.json": [
		1507,
		5249
	],
	"./wheel.fr.json": [
		73567,
		7689
	],
	"./wheel.pt.json": [
		99807,
		861
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 96476;
module.exports = webpackAsyncContext;